<template>
  <div class="x-empty">
    <x-svg-icon class="empty-icon" name="x-lib-empty"></x-svg-icon>
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <span v-else class="empty-text">暂无数据</span>
  </div>
</template>

<script>
export default {
  name: 'XEmpty'
}
</script>

<style lang="scss">
.x-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-icon .svg-icon {
    width: 4.71rem !important;
    height: 3.43rem !important;
  }
  .empty-text {
    margin-top: 0.57rem;
    font-size: $--app-base-font-size;
    color: $--app-notice-font-color;
  }
}
</style>